import(/* webpackMode: "eager" */ "/app/src/app/network-dao/resource/page.jsx")